export const CHAT_MESSAGE_TYPES = {
    PROMPT_ALERT: { value: "PROMPT_ALERT", text: "프롬프트 안내" },
    PROMPT_QUERY: { value: "PROMPT_QUERY", text: "프롬프트 질문" },
    PROMPT_REPLY: { value: "PROMPT_REPLY", text: "프롬프트 답변" },
};
